var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpskillingPathwaysArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 51.024,
    height: 117.657,
    viewBox: "0 0 51.024 117.657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18427",
    "data-name": "Rectangle 18427",
    width: 51.024,
    height: 117.657,
    fill: "#3db6fb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47755",
    "data-name": "Group 47755",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47754",
    "data-name": "Group 47754",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46660",
    "data-name": "Path 46660",
    d: "M5.914,65.1c-.156.047-.327.315-.108.425l.478-.291Z",
    transform: "translate(3.472 39.636)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46661",
    "data-name": "Path 46661",
    d: "M6.381,66.622a1.155,1.155,0,0,0,1.1-.64c-.541.211-.454.008-1.075.274a.313.313,0,0,1-.042-.523c-.153.048-.2-.328-.516-.161-.039.513.248.784.777.793-.01.146-.166.2-.245.257",
    transform: "translate(3.559 39.899)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46662",
    "data-name": "Path 46662",
    d: "M18.923,72.774l-.159-.053a.3.3,0,0,0,.159.053",
    transform: "translate(11.425 44.279)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46663",
    "data-name": "Path 46663",
    d: "M27.027,68.652c-.068.093-.06.164-.026.2.045-.1.077-.19.026-.2",
    transform: "translate(16.426 41.802)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46664",
    "data-name": "Path 46664",
    d: "M28.328,67.6l-.119.1c.074-.019.13-.051.119-.1",
    transform: "translate(17.176 41.162)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46665",
    "data-name": "Path 46665",
    d: "M18.863,72.754l.415.14c.013-.175-.217-.114-.415-.14",
    transform: "translate(11.486 44.299)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46666",
    "data-name": "Path 46666",
    d: "M8.3,66.873a.487.487,0,0,0-.246-.023,1.9,1.9,0,0,1,.183.079Z",
    transform: "translate(4.902 40.701)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46667",
    "data-name": "Path 46667",
    d: "M14.844,72.5l-.119-.034a1.38,1.38,0,0,0-.164.177Z",
    transform: "translate(8.866 44.124)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46668",
    "data-name": "Path 46668",
    d: "M11.807,71.473c.093.071.339-.311.47-.465a.442.442,0,0,1-.364.159,1.06,1.06,0,0,0-.106.306",
    transform: "translate(7.189 43.236)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46669",
    "data-name": "Path 46669",
    d: "M8.077,68.184l-.146-.035.146.035",
    transform: "translate(4.829 41.495)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46670",
    "data-name": "Path 46670",
    d: "M16.974,73.026a.48.48,0,0,0,.029.166.333.333,0,0,0-.029-.166",
    transform: "translate(10.335 44.465)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46671",
    "data-name": "Path 46671",
    d: "M5.332,3.669l.051-.063c-.051.019-.079.039-.051.063",
    transform: "translate(3.24 2.195)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46672",
    "data-name": "Path 46672",
    d: "M3.467.461,3.543.49,3.709.3Z",
    transform: "translate(2.111 0.181)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46673",
    "data-name": "Path 46673",
    d: "M30.077,65.153l-.016.016c0,.138.016.068.016-.016",
    transform: "translate(18.304 39.671)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46674",
    "data-name": "Path 46674",
    d: "M30.31,39.127c-.285.553-.682-.627-.956.169.158-.106.837.467.956-.169",
    transform: "translate(17.873 23.753)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46675",
    "data-name": "Path 46675",
    d: "M8.24,66.94a1.365,1.365,0,0,1,.156.117.368.368,0,0,0-.156-.117",
    transform: "translate(5.017 40.759)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46676",
    "data-name": "Path 46676",
    d: "M29.365,39.188h0l-.024.082.027-.082",
    transform: "translate(17.864 23.861)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46677",
    "data-name": "Path 46677",
    d: "M31.7,58.532a.579.579,0,0,0-.209.085.359.359,0,0,0,.209-.085",
    transform: "translate(19.175 35.64)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46678",
    "data-name": "Path 46678",
    d: "M30.174,63.389l.121-.169a.5.5,0,0,0-.121.169",
    transform: "translate(18.373 38.494)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46679",
    "data-name": "Path 46679",
    d: "M31.424,56.053c.039-.1.1-.138.048-.285a.256.256,0,0,0-.056.042c.06.055.085.125.008.243",
    transform: "translate(19.129 33.957)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46680",
    "data-name": "Path 46680",
    d: "M31.476,53.31a.835.835,0,0,0-.088.079l.026.134Z",
    transform: "translate(19.112 32.46)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46681",
    "data-name": "Path 46681",
    d: "M11.14,8.982a1.38,1.38,0,0,1,.159-.413c-.188.265-.7-.08-.159.413",
    transform: "translate(6.637 5.217)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46682",
    "data-name": "Path 46682",
    d: "M8.1,67.04c.09-.074.153-.095.217-.074L8.2,66.9a.236.236,0,0,0-.1.142",
    transform: "translate(4.935 40.734)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46683",
    "data-name": "Path 46683",
    d: "M29.21,56l.084-.637A2.983,2.983,0,0,0,29.21,56",
    transform: "translate(17.786 33.709)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46684",
    "data-name": "Path 46684",
    d: "M21.716,23.658l-.121-.1a.146.146,0,0,0,.121.1",
    transform: "translate(13.149 14.341)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46685",
    "data-name": "Path 46685",
    d: "M29.236,54.344a.937.937,0,0,0,.309-.365.4.4,0,0,0-.117-.074Z",
    transform: "translate(17.802 32.822)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46686",
    "data-name": "Path 46686",
    d: "M11.151,8.567l0,0Z",
    transform: "translate(6.789 5.216)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46687",
    "data-name": "Path 46687",
    d: "M12.352,11.512c.426.446.611-.211.943-.362.642.4-.066.555-.1.948.434.214,1.072.079,1.3.339-.051.087-.029.159-.172.19.682.014,1.039,1.007,1.873,1a.349.349,0,0,1-.055.154,2.194,2.194,0,0,1,.529-.624c.211.187.636.117.422.463-.106-.135-.228-.039-.372-.016l.319.1c-.232.579-.4-.171-.711.119.518.294,1.3.483,1.475.917-.343.438-.817-.64-.785.125l-.3-.647c-.286.973-.228-.346-.587.637.471.766.862.549,1.332,1.314.357-.055.29-.351.648-.405,1.249.582-.37,1.651.79,1.858.434-.061,1.022-.442,1.184.29l-.619.233c.518.682,1.017-.219,1.26.755-.286.031-.578-.4-.553-.248-.011.769.526.1.806.449l-.364.422c.634.658,1.569,1.2,2.281,1.934-.163.056-.405.026-.389.315a5.89,5.89,0,0,1,1.266,1.541,15.245,15.245,0,0,1,.8,1.845l.655.106c.06.093-.056.29-.2.246.13.5.257-.153.542-.074a.234.234,0,0,1-.228.394c.809.457,2.117,1.475,2.2,2.5l-.209-.069c.211.693,1.226.132,1.2.922l-.135-.06c.632,1.388,1.9,2.582,1.9,3.924.722-.174.478,1.45,1.35,1.055.013.991-.254.859.058,2.071.119.3.753.135,1.036.439l-.431.246.722.227-.381.534.294.269a.39.39,0,0,1,.179-.431,1.279,1.279,0,0,1,.159,1.549l.98,1.055c-.191.063-.354-.116-.547-.224.775.438-.409.356.3.756.061-.132.285-.087.383-.117a2.19,2.19,0,0,0,.576,1.586l-.356.05c.354.964,1.133,1.857,1.546,2.935a.43.43,0,0,1,.748-.309l-.426.336c.381.072.042-.407.581-.151.113.425-.434.507-.685.348l.37.41c-.132.092-.256.011-.45.061.383.069-.134,1.038.505,1.1l-.132.088c.442,1.06.812,1.472,1.2,2.328.425-.148.486.222.92.356a8.957,8.957,0,0,0,.339,2.323c.409.475.418.031.759.188-.372.18-.055.951-.479.644a10.073,10.073,0,0,0,1.252,2.26c.114-.183.132-.352.291-.32a.4.4,0,0,1-.193.581l-.058-.045c1,1.187-.219,3.491.927,4.326l-.06-.05.766,1.006c.085.537-.391-.228-.525.22.994,1.044.373,1.961,1.065,2.861-1.014,1.062.779,2.756.2,3.988l.27-.119c.323.222-.1.367-.13.582.212-.072.2-.349.383-.209.73,2.286.518,4.9.479,7.337.027.886,1.53.325.985,1.522l-.566-.259a6.89,6.89,0,0,1,.6,2.68,8.472,8.472,0,0,0,.383,2.684c-.129-.1-.288-.09-.3-.262-.364.394.063,1.369.378,1.363-.019.275-.28.077-.43.253-.206.38.547.914.175,1.125-.061.037-.132-.1-.166-.166.209.235.01,1.128.442.883-.195.664.225,1.258-.035,1.786.505.343-.243,1.121.462,1.236-.721-.051-.607,1.136-.277,1.562-.214-.145-.243.351-.541.177-.011.467.1.9.481.84-.914.8.586,1.794-.576,2.182a16.894,16.894,0,0,1,.27,3.987c-.7-.179.175-1.371-.6-1.442.109,1.192.59,2,.143,3.1-.171.269-.264-.241-.36-.367.018,1.212-.64,2.146-.6,3.248-.063-.026-.1-.156-.116-.274-.042.2-.251.412.063.5l-.018-.217c.57-.154.655,1.112.869,1.247-.747-.671-.608.886-1.5-.084a.433.433,0,0,0,.3.417c-.138.161-.282.166-.433-.117-.129.73.312.653.013,1.244-.143-.071-.14-.217-.28-.357a1.217,1.217,0,0,1-.116,1.311c-.068-.074-.209-.077-.125-.22-.413.846-.1,1.86-.965,2.582-.388-.65-.4.166-.917-.143-.061.185-.114.378-.185.558l.368,0c-.307.385-.248,1.006-.673,1.216l.043-.447c-.158.272-.344.521-.521.78l.526-.246c-.108.584.611.455.029.856.045-.148-.344.394-.8.325v0c-.04.309-.087.64-.46.8-.2-.071-.4-.537-.534-.586.161.529-.764.885-.674,1.485a.69.69,0,0,0-.261-.438l.095.444c-.267.043-.331.014-.457-.208-.592.37.64.465-.216.721.032-.068-.029-.1.04-.23-.764.354-1.186,1.137-1.961,1.348-.487-.413.5-.467.018-.777-.837.642-1.657,1.693-2.725,1.9l.209,0c.125.841-.878-.122-1.277.368.113-.093.043-.5.035-.4a13.6,13.6,0,0,0-2.437.9l.116-.227c-.441-.182-1.118,0-1.577-.146-.137.214-.4.171-.248.494a2.164,2.164,0,0,0-2.035-.436,1.764,1.764,0,0,1-1.871-.5c.146.047.394-.092.278-.119l-1.088-.111c-.027.38.069.256.211.6a.943.943,0,0,1-.822.164c.562-.093.175-.562.048-.833,0,.121-.113.214-.134.33-.319-.827-.343.669-.941-.031l.109-.167c-.314-.013-.674.135-.948-.058.048-.45.37-.053.524-.372-.41-.159-1.142.378-1.34-.182.227-.029.479.084.7.053-.2-.642-.291-.544-.553-.75l.024.023c-.195-.171-.378-.365-.565-.545l.106.211c-1.01.735-1.107-.331-2.122-.092.991-.225.306-.286.6-.679-.1-.214-.27-.491-.129-.566-.508.158-.344-.555-1.067-.344.066-.143-.311-.219-.029-.507-.454-.145-.058.288-.2.434-.907.064-1.026-1.464-2.286-1.466-.891-.3-1.358.04-2.18-.278-.069-.373.534-.307.534-.307a1.3,1.3,0,0,0-.961-.767c.153-.053.156-.2.164-.417-.291-.187-.539.3-.743-.171a2.21,2.21,0,0,1,.663-.27c-.4-.145-.9-.172-1.314-.331.09-.282.462-.158.69-.2-.444-.2-1.094-.6-1.487-.359l.132.314c-.145-.095.172-.341.32-.319.528,0,.349.494.267.629l-.294-.117c-.357.909,1.028.658,1.456,1.081l-.618.359.833-.042c0,.217-.166.568-.465.459.138.529.452.053.518.576,0,.071-.037.084-.084.08l.459.108c-.153.06-.233.418-.381.179.37.788,1.3.349,1.22.933l-.076-.006c.993.455.373-.325,1.355-.33l-.259,1.3.367-.341c.08.077.238.232.093.372.528-.042.064-.217.439-.343.182.679,1.331.618,1.009,1.348.357-.212-.272-.518.341-.431-.314.808.629.222.848.795-.349.3-.636-.137-.407.447.627-.489.737.634,1.189.7.3-.513.906.22,1.627.331-.121.15,1.047.858,1.607,1.26l-.055.085c.336-.516.911-.145,1.422-.134a.663.663,0,0,1-.565.508l.454.135a.763.763,0,0,1,.64-.182l-.237.391c.616.177,1.347-.18,2.074.27.108-.4-.38-1.252.452-1.356-.01.225-.043.607-.272.652.076-.018.277-.122.4-.018-.129.114-.257.212-.388.312.325.237.237-.274.512-.2-.055.314.177.251.1.5-.079.021-.232-.161-.362-.051a1.337,1.337,0,0,1,.8.587c-.01-.183.05-.425.293-.436.621.047.175.417.536.6.169-.216.566.026.594-.449.183.008.212.23.282.36.335-.166,1.538-.085,1.147-.576l-.084-.029.051-.024h0c.993-.523,2.207.09,3.2-.393l.037.154c.571-.3,1.311-.507,1.615-.957.167-.064.5.108.5.314.4-.3.38-.459,1.112-.521-.317.462.262.163-.365.393.629-.126.877.01,1.281-.673-.011.473.668.216.864-.051l-.528-.026a3.11,3.11,0,0,1,.806-.463l.142.537c1.517-.183,1.284-2.22,2.706-2.013.013-.508-.7.262-.75-.275.478-.323,1.461-.169,1.606-.3.793-.381.006-1.086.721-1.562a.594.594,0,0,1-.378-.9c.428-.373,1.081-.01.949.37-.082.116-.174.127-.219.08-.074.187-.182.43.13.393l-.092-.185c.351-.082.858-.732.973-.386.143-.471-.122-.348-.405-.153.693-.422.756-.919,1.353-1.456-.159.042-.407,0-.335-.095.858-.8-.011-.618.336-1.3.478-.211.5.5.713-.283.405-.314.494.172.52.418.045-.812.893-1.054,1.141-1.409l-.042.418a1.707,1.707,0,0,1,.2-.594l-.438.026c.159-.172.246-.343.386-.269-.122-.317-.645-.127-.755-.679.315-.179.179-.888.682-.775-.526.774.51.111.264.869a.88.88,0,0,1,.237-.513c.064-.008.084.071.085.14.769-.652-.344-.6,0-1.45a.36.36,0,0,0,.579-.167c-.14.349-.508-.006-.594-.4.422-.468.056-.652.182-.928l-.209.293c-.232-.2-.106-.463-.064-.869.222.035.029.391.169.286-.33-.568.795-.808.648-1.506.265-.227.528.116.719-.1-.191-.779.579-.652.441-1.453-.42.127-.335.179-.592-.405.008.412,0,.824-.011,1.239l-.36-.882c-.082.349.051.8-.063.994-.212-.434-.13-.372-.481-.283.685-.341-.1-1.018.4-1.485l.927.211c.594-.779-.182-1.6.212-2.668l-.217.331c-.354-.2.055-.687-.06-1.063.311.072.452-.137.666-.267-.235-.008.119-.816-.508-.978l.462-.454c.253-.886-.824-1.089-.66-1.927.331.275.581-.1.788.489.026-.288.093-.544-.125-.56.206-.159-.391-.812-.079-1.062-.135-.125-.467-.175-.433-.492a.213.213,0,0,1,.156,0c-.156-.006-.2-.5-.558-.235,1.022-.856-.048-2.429.79-3.2-.119-.618-.238-1.36-.3-1.916.1.032.159,0,.132.1.249-.785-.94-.438-.661-1.326.486-.473.3.452.483.162,1.036-.172-.206-1.052.368-1.68l.069.14c.328-.478-.46-1.081-.43-1.824a.23.23,0,0,0,.158-.008,5.032,5.032,0,0,1-1.051-2.087c.433.179.253.3.652.124-.1-.311-.653.158-.845-.459.2-.227.339-.7.774-.812l.093.6c.536-.367-.111-.772-.048-1.1l.253.011c-.19-.911-.817-.845-.89-1.831l-.177.127c-.682-.45.3-.5-.228-.967l.61-.251a14.9,14.9,0,0,1-1.025-1.75,5.047,5.047,0,0,1,1.244,1.4c-.035-.354-.251-1.183-.587-1.314.085.13.27.283.2.438a2.146,2.146,0,0,1-1.022-1.562c1.234-.087-.014-1.857.833-2.54-.636-1.15-.306-2.476-.713-3.887-.816.719-.125-.41-1.062-.1-.14-.314-.154-.442-.1-.487l.335-1.137c.22-.307.285.262.492.179-.1-.745.331-.405.47-.952-.317.185-.547-.129-.516-.576l-.3.7c-.753-.878.613-1.094-.193-1.969l.393.24c-.33-.471-.562-1.921-1.471-2.2.082-.122.3-.32.439-.113-.269-1.273-1.588-2.507-1.469-3.594l.261.016c-.146-.2-.57-.249-.441-.61.1-.018.261.014.237-.095-.122-.095-.615-.465-.589-.809l.348.167c-.127-1.292-1.271-1.6-1.778-2.521.661-.243.553-1.261.478-1.763l.1-.021c-.489-1.388-1.512-2.08-2.291-3.211.393-1.084-.8-2.753-1.039-4.136-.026.241-.513.206-.682.023-.01-.348-.825-.573-.219-.811l.039.106c.468-.492.029-1.007-.179-1.474l-.8.306c.553-1.778-2-2.872-1.38-4.025-.343-.179-.533-.528-.874-.7l.407-.208a8.641,8.641,0,0,0-1.131-2.164l.391.032c-.272-.565-1.522-.013-1.847-.478l.491-.5c-.582-.906-.664-2.156-1.755-2.73.093-.039.275-.117.393.016-.256-.439-.669-1.926-1.348-1.252.513-.356-.568-.965-1.133-1.282l.422-.179c-.758-.079-.895,0-1.421-.468-.045-.166.212-.322.243-.08-.121-.576-.59-.1-.775-.771l.375.034c-.294-.475-.394-.351-.841-.4a.944.944,0,0,1-.238-1.234c-.243.085-.685.034-.78-.3a.268.268,0,0,1,.314-.066c-.286-.951-1.261-.777-1.3-1.553a.353.353,0,0,0,.143-.248,6.816,6.816,0,0,1,.745,1.043c.33-.248.013-.763.766-.734-.552-.191-1.6-.422-1.81-1a.566.566,0,0,1,.064-.148l.076.018a.447.447,0,0,0-.283-.248,1.439,1.439,0,0,0-.2-.455c.224-.269-.286-.656-.46-.9-.336.3-.523-.047-.584.475,0-.058.077.01.214.153a.346.346,0,0,0,.116.071L24,18.51l.486.56c-.327-.04-.631-.111-.64-.526-.32.063-.656.121-.825.135.238-.714.01-1.548.24-1.884-.75-.563-1.548-1.514-2.555-1.39-.254-.121-.014-.383.021-.542.164.055.272.2.418.175-.508-.243-1.086-1.089-1.609-.784-.233-.664.65-.093-.018-.7l.214-.032c-.467-1.99-3.03-1.068-3.536-3.282.042.148.066.22.014.309a10.88,10.88,0,0,0-2.36-2.441,7.818,7.818,0,0,1-2.315-2.473c-.354-.544-.655-.306-1.128-.341l.219-.455-.853-.008c-.938-.309-.434-1.964-1.855-2.087L7.832,3.1c-.29-.307-1.16-.671-.87-.922-.071.019-.32.18-.343-.055l.148-.208L5.692,1.618C5.179.978,6.408.9,5.52.132,5.116-.061,4.1-.044,4.132.195a.509.509,0,0,1,.111.615L3.855.671c-.505.555-1.192.989-.764,2l.795.047-.053.42-.45-.327c.04.468.38.351.682.325a.626.626,0,0,0-.027.489l.948-.162c-.119.28-.586.277-.346.674.444-.072.177-.7.708-.555.039.463-.208.623.265.626a.326.326,0,0,1-.386.2c.4.024.745.465,1.129.262-.006.529.946.608.468,1.134a1.545,1.545,0,0,1,1.055.117c-.964.28.816.795.113,1.387.8-.306,1.323.726,2.146.893-.071.018-.212.056-.233-.014.262.319.2.568.294.848.463-.431,1.036-.113,1.559-.167-.039.779-.732.338-1.01.872.328-.393,1,.2,1.16-.219.031.526.114.362-.1.877.59-.524.343.154.9.031.124.673-.412.631.185.89.035.376-.541.195-.541.195m10.665,9.861-.006.006-.208-.22.214.214m.769.954a4.31,4.31,0,0,0-.317-.426c.1-.129.253-.191.323-.09-.124.011-.016.293-.006.516m.83-3.988c.174.116.146.224.092.3a3.029,3.029,0,0,0-.261-.238l-.056.016a.734.734,0,0,1,.225-.08",
    transform: "translate(1.8 0)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46688",
    "data-name": "Path 46688",
    d: "M16.025,11.471c-.026-.016-.05-.016-.077-.043a1.043,1.043,0,0,0,0,.156l.154-.034Z",
    transform: "translate(9.706 6.958)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46689",
    "data-name": "Path 46689",
    d: "M18.759,72.735l.027.008a.175.175,0,0,1-.06-.06c.019.019.019.034.032.051",
    transform: "translate(11.403 44.257)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46690",
    "data-name": "Path 46690",
    d: "M21.153,22.986l.1-.056-.14-.045Z",
    transform: "translate(12.855 13.934)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46691",
    "data-name": "Path 46691",
    d: "M14.757,71.2a.229.229,0,0,0-.042-.14.289.289,0,0,0,.042.14",
    transform: "translate(8.959 43.269)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46692",
    "data-name": "Path 46692",
    d: "M13.246,70.54c-.1-.1-.191-.219-.286-.325a1.46,1.46,0,0,0,.286.325",
    transform: "translate(7.891 42.753)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46693",
    "data-name": "Path 46693",
    d: "M12.056,69.654a.94.94,0,0,0-.134.146l0,0Z",
    transform: "translate(7.259 42.412)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46694",
    "data-name": "Path 46694",
    d: "M28.368,62.881a.252.252,0,0,0,.006-.085c-.021-.211-.031-.076-.006.085",
    transform: "translate(17.265 38.17)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46695",
    "data-name": "Path 46695",
    d: "M25.712,68.67a2.168,2.168,0,0,1,.079-.385c-.151.109-.261.2-.079.385",
    transform: "translate(15.598 41.578)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46696",
    "data-name": "Path 46696",
    d: "M29.2,55.826l.008,0,0-.071Z",
    transform: "translate(17.782 33.95)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46697",
    "data-name": "Path 46697",
    d: "M26.049,68.067a.527.527,0,0,0-.325.352.792.792,0,0,0,.325-.352",
    transform: "translate(15.663 41.445)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46698",
    "data-name": "Path 46698",
    d: "M7.316,66.085,7.245,66a.145.145,0,0,1-.056.047Z",
    transform: "translate(4.377 40.187)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46699",
    "data-name": "Path 46699",
    d: "M7.236,66.044l-.125-.037c.042.035.08.064.125.037",
    transform: "translate(4.33 40.191)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46700",
    "data-name": "Path 46700",
    d: "M6.946,65.967l.265.077c-.066-.058-.138-.138-.265-.077",
    transform: "translate(4.229 40.153)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46701",
    "data-name": "Path 46701",
    d: "M8.607,67.356l.129-.108a.384.384,0,0,0-.129.108",
    transform: "translate(5.241 40.947)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46702",
    "data-name": "Path 46702",
    d: "M9.292,67.9c-.148-.158-.206-.607-.5-.708l-.1.085c.259-.108.274.721.6.623",
    transform: "translate(5.289 40.914)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46703",
    "data-name": "Path 46703",
    d: "M10.58,70.226,10,69.69c.013.222.029.52-.286.352.531.98.047-.431.862.183",
    transform: "translate(5.917 42.434)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46704",
    "data-name": "Path 46704",
    d: "M11.542,70.956c-.405-.143-.122.224-.188.3.311,0,.385,0,.188-.3",
    transform: "translate(6.891 43.185)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46705",
    "data-name": "Path 46705",
    d: "M22.194,72.184l.113.4c.3-.187-.056-.15-.113-.4",
    transform: "translate(13.514 43.952)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46706",
    "data-name": "Path 46706",
    d: "M23.53,70.109l-.381-.068.079.393Z",
    transform: "translate(14.095 42.648)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46707",
    "data-name": "Path 46707",
    d: "M25.467,70.973l-.082.14.359-.473Z",
    transform: "translate(15.457 43.012)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46708",
    "data-name": "Path 46708",
    d: "M31.889,53.775l-.507.1c.093.216.663.259.507-.1",
    transform: "translate(19.108 32.743)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46709",
    "data-name": "Path 46709",
    d: "M30.806,46.281c.235-.169.354-.542.082-.726,0,.286-.164.592-.082.726",
    transform: "translate(18.743 27.738)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46710",
    "data-name": "Path 46710",
    d: "M24.359,23.656l.262.151-.335-.365Z",
    transform: "translate(14.788 14.273)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46711",
    "data-name": "Path 46711",
    d: "M18.986,4.861c.019-.14-.013-.452-.092-.388l-.029.533Z",
    transform: "translate(11.487 2.718)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46712",
    "data-name": "Path 46712",
    d: "M18.624,4.106a2.7,2.7,0,0,0-.1,1.2c.079-.513.109-.3.188-.912.077-.064.146.167.142.364.023-.137.132.114.159-.22-.125-.41-.253-.423-.38-.08a1.144,1.144,0,0,1-.006-.354",
    transform: "translate(11.26 2.5)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46713",
    "data-name": "Path 46713",
    d: "M13.873,3.213l.037.071a.1.1,0,0,0-.037-.071",
    transform: "translate(8.447 1.956)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46714",
    "data-name": "Path 46714",
    d: "M11.024,2.474c.039,0,.064-.053.077-.1-.04.027-.074.053-.077.1",
    transform: "translate(6.712 1.445)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46715",
    "data-name": "Path 46715",
    d: "M10.615,1.973l.039.047c-.006-.053-.018-.084-.039-.047",
    transform: "translate(6.463 1.191)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46716",
    "data-name": "Path 46716",
    d: "M13.913,3.283,13.818,3.1c-.039.169.04.137.095.185",
    transform: "translate(8.407 1.886)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46717",
    "data-name": "Path 46717",
    d: "M17.909,4.975a.338.338,0,0,0,.072-.142.432.432,0,0,1-.068.058Z",
    transform: "translate(10.905 2.943)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46718",
    "data-name": "Path 46718",
    d: "M15.186,3.219l.035,0c.018-.058.037-.13.06-.209Z",
    transform: "translate(9.247 1.834)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46719",
    "data-name": "Path 46719",
    d: "M16.207,3.2a2.946,2.946,0,0,0-.119.623.657.657,0,0,1,.106-.3c.008-.085.013-.188.013-.32",
    transform: "translate(9.796 1.947)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46720",
    "data-name": "Path 46720",
    d: "M17.689,3.8l.045-.061Z",
    transform: "translate(10.771 2.277)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46721",
    "data-name": "Path 46721",
    d: "M14.5,3.042c0-.068.008-.125.011-.162a.953.953,0,0,0-.011.162",
    transform: "translate(8.828 1.753)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46722",
    "data-name": "Path 46722",
    d: "M10.236,15.18l-.079.014c.047,0,.079,0,.079-.014",
    transform: "translate(6.185 9.243)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46723",
    "data-name": "Path 46723",
    d: "M9.118,16.587l-.027-.023-.253.024Z",
    transform: "translate(5.381 10.086)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46724",
    "data-name": "Path 46724",
    d: "M9.8,1.412l0,.01c.05-.04.026-.037,0-.01",
    transform: "translate(5.964 0.847)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46725",
    "data-name": "Path 46725",
    d: "M.7,1.437c.555.1,1.094.706,1.66.745C2.09,2.092.972,1.369.7,1.437",
    transform: "translate(0.427 0.872)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46726",
    "data-name": "Path 46726",
    d: "M17.909,4.884a.18.18,0,0,1-.071.006c.032.014.055.011.071-.006",
    transform: "translate(10.861 2.974)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46727",
    "data-name": "Path 46727",
    d: "M1.734,1.9l.006,0,.053,0L1.734,1.9",
    transform: "translate(1.056 1.156)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46728",
    "data-name": "Path 46728",
    d: "M7.655,1.08a1.283,1.283,0,0,0-.008.2.87.87,0,0,0,.008-.2",
    transform: "translate(4.656 0.657)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46729",
    "data-name": "Path 46729",
    d: "M9.149,1.86,9.1,1.786a.117.117,0,0,0,.048.074",
    transform: "translate(5.542 1.087)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46730",
    "data-name": "Path 46730",
    d: "M6.776,1.32c-.027-.042-.026-.1-.085-.055l0,.056c.029-.056.058-.08.082,0",
    transform: "translate(4.074 0.759)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46731",
    "data-name": "Path 46731",
    d: "M5.883,1.124c0,.035.006.063.008.095l.05-.016Z",
    transform: "translate(3.582 0.684)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46732",
    "data-name": "Path 46732",
    d: "M9.536,12.518a3.133,3.133,0,0,1-.367.187c.3-.119.473.053.367-.187",
    transform: "translate(5.583 7.622)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46733",
    "data-name": "Path 46733",
    d: "M17.925,4.763a.374.374,0,0,1-.043.2.352.352,0,0,0,.048-.026.63.63,0,0,0,0-.171",
    transform: "translate(10.888 2.9)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46734",
    "data-name": "Path 46734",
    d: "M6.335,3.5l-.2-.111a.375.375,0,0,0,.2.111",
    transform: "translate(3.737 2.063)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46735",
    "data-name": "Path 46735",
    d: "M6.746,6.678l.072.019c0-.023-.021-.032-.072-.019",
    transform: "translate(4.108 4.063)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46736",
    "data-name": "Path 46736",
    d: "M5.783,3.478a.929.929,0,0,0-.058-.33.576.576,0,0,0-.047.111Z",
    transform: "translate(3.457 1.917)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46737",
    "data-name": "Path 46737",
    d: "M9.165,12.636l0,0Z",
    transform: "translate(5.58 7.693)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46738",
    "data-name": "Path 46738",
    d: "M16.211,21.388c-.045-.222-.589.05-.93.095-.228-.209.391-.235.661-.405-.191-.122-.759-.088-.771-.211a.57.57,0,0,1,.245-.077c-.505-.032-.177-.489-.8-.505a.885.885,0,0,1,.134-.069,6.148,6.148,0,0,1-.769.274c-.039-.088-.41-.055-.051-.208.006.06.158.016.282.006l-.191-.045c.505-.259.225.072.619-.051-.233-.138-.74-.212-.636-.405.508-.2.28.282.682-.066l-.129.293c.766-.439-.013.156.814-.286.053-.354-.365-.256-.323-.6-.311.032-.417.167-.727.2-.664-.232,1.178-.785.38-.851-.372.043-1.031.251-.766-.092l.607-.14c-.047-.309-.891.15-.61-.294.246-.035.272.15.327.08.385-.367-.375-.013-.434-.158l.5-.227c-.2-.27-.7-.452-.927-.74a.837.837,0,0,0,.462-.193c-.417-.315-.309-.911-.195-1.44l-.5.042c-.011-.037.166-.153.265-.153.093-.228-.277.116-.478.119-.069-.074.195-.228.348-.232-.483-.111-1.129-.4-.814-.9l.153-.006c.066-.3-.991.177-.693-.216l.095,0c-.043-.566-.69-.882-.248-1.562-.639.249.026-.6-.829-.187.275-.484.468-.492.542-1.014-.016-.119-.6.138-.756.064l.433-.241-.547.087.47-.376-.175-.051c0,.06-.14.2-.269.267-.294-.066.06-.6.278-.73l-.6-.214a.794.794,0,0,1,.418-.061c-.565.027.431-.3-.09-.274a1.429,1.429,0,0,1-.354.177.363.363,0,0,0-.142-.589l.314-.14c-.108-.352-.521-.568-.722-.914-.063.2-.587.481-.7.412l.423-.311c-.315.1-.1.206-.524.28-.026-.158.457-.394.648-.409l-.249-.061a3.459,3.459,0,0,1,.4-.19c-.317.1.285-.542-.254-.339l.127-.09c-.2-.343-.454-.4-.645-.666-.388.233-.368.072-.73.185,0-.275.156-.689-.031-.909-.3-.05-.354.154-.629.222.311-.278.22-.348.507-.45a2.041,2.041,0,0,0-.547-.08,1.973,1.973,0,0,1-.375.125c-.095-.023.127-.122.341-.154l.05,0c-.385-.024-.146-.208.146-.253.278-.066.6-.006-.006-.156l.061.016a7.167,7.167,0,0,1-.7-.257c.064-.027.467.151.811.214-.526-.179-.536-.238-.476-.245s.174.019-.238-.193c.988.4.959.4.8.291s-.452-.307.293.121L7.7,4.942c-.558-.341.307.171.436.248L7.327,4.7,7.283,4.67c-.22-.159-.13-.142-.021-.1a3.566,3.566,0,0,1,.492.254,4.954,4.954,0,0,1,.909.685c.061.088-1.6-1.747-.764-.928l.5.618c-.282-.368-.167-.351-.1-.32.085.031.129.069.13-.208.026.13.076.3.064.3.138.417.068.031.043-.294a3.1,3.1,0,0,1,.08.467c.023.235.031-.5.055-.1,0,.06-.008.122-.01.156.011-.188.05.058.082-.389-.039.209.341-.135.436.15.206-.467.319.306.492-.378-.158.708.259.648.465.344-.09.206.072.248-.043.536.156.023.327-.079.376-.45.1.912.722-.563.648.562a4.791,4.791,0,0,1,1.488-.512c-.177.7-.478-.035-.627.711.46-.2.829-.756,1.183-.5.079.121-.13.294-.191.407.463-.2.751.245,1.2-.058a.393.393,0,0,1-.119.174c.074-.006.137.142.2-.18l-.088.071c0-.492.507-.909.578-1.152-.336.893.3.314-.167,1.432a.728.728,0,0,0,.193-.405c.053.079.045.209-.08.438.29-.116.283-.478.508-.417a3.238,3.238,0,0,1-.164.381c.187-.275.375-.552.536-.375-.034.09-.04.219-.1.2.341.031.751-.674,1.046-.3-.265.65.071.251-.047.84l.237-.129-.013-.3c.171.05.42-.341.523-.116l-.183.211.348-.037-.13-.264c.243-.261.151-.745.341-.529-.06.048.169.047.18.412v0c.127-.167.257-.343.351-.169-.008.195-.172.642-.179.771.195-.47.433-.042.655-.542a1.91,1.91,0,0,0-.135.487l.159-.383a.594.594,0,0,1-.018.45c.225.125.088-.759.3-.378-.029.027-.032.09-.092.14.251.228.608-.135.829.117-.047.608-.261.1-.277.615.4-.024.935-.542,1.277-.335l-.056-.079c.216-.827.195.468.46.109a1.124,1.124,0,0,0-.119.362c.23.183.56-.1.991-.3l-.087.209c.117.217.378.175.526.3.084-.208.172-.158.167-.481.309,1.311,1.051-.5,1.35.581-.055,0-.156.174-.113.18l.412-.151c.018-.372-.021-.228-.063-.526.077-.212.206-.368.3-.357-.2.224-.076.594-.027.808,0-.114.043-.235.051-.351.117.681.125-.738.339-.262l-.037.191c.114-.085.235-.33.338-.261,0,.433-.13.185-.177.536.158-.006.391-.766.484-.331-.079.114-.172.106-.251.216.1.523.13.393.237.483l-.01-.011.243.249-.055-.142c.3-1.1.418-.171.738-.882-.307.673-.074.4-.132.882.056.14.148.3.108.434.154-.381.19.327.407-.232,0,.156.134.026.08.417.172-.109-.023-.275,0-.47.277-.51.562.674.959-.045.323-.291.393-.819.677-1.073a.8.8,0,0,1-.087.57c.151.235.27.2.418.021a.875.875,0,0,0,.045.428c.119-.043.079-.573.235-.346a4.426,4.426,0,0,1-.117.634c.143-.148.28-.444.422-.589a1.136,1.136,0,0,1-.132.6.871.871,0,0,0,.462-.692l-.106-.153c.058-.023.039.372,0,.45-.134.343-.206-.145-.216-.3l.1-.1c-.119-.917-.405.158-.616.109l.085-.671-.211.558c-.043-.175-.069-.55.031-.647-.142-.336-.13.233-.249-.14a.162.162,0,0,1,.006-.116l-.143.195c.029-.14-.014-.473.069-.373-.24-.394-.417.487-.5-.023l.021-.04c-.354.214-.048.491-.336,1.057l-.124-1.216-.056.489c-.035-.018-.1-.058-.082-.253-.151.331.013.214-.082.528-.15-.447-.5.18-.483-.6-.087.367.146.3-.056.544.006-.845-.225.125-.356-.272.084-.43.212-.188.087-.587-.153.724-.291-.187-.433-.056-.06.581-.311.219-.552.394.034-.188-.383-.37-.562-.6l.018-.1c-.109.582-.311.444-.481.545a1.289,1.289,0,0,1,.2-.631l-.145-.016a.494.494,0,0,1-.219.331l.095-.433c-.193,0-.459.47-.664.14-.076.405.034,1.168-.275,1.4a1.787,1.787,0,0,1,.153-.679c-.027.024-.108.169-.14.068l.161-.354c-.088-.18-.106.3-.191.251.05-.314-.034-.235.018-.483.027-.026.06.143.113.026a.725.725,0,0,1-.191-.523c-.018.179-.064.422-.146.45-.2-.008-.006-.388-.092-.568-.08.211-.166-.035-.246.433-.056-.011-.031-.232-.031-.362-.134.19-.473-.016-.447.5l.019.037-.019.018c-.412.417-.634-.388-.994-.248l.031-.156c-.227.14-.45.023-.655.33-.058-.011-.079-.311-.018-.491-.171.088-.224.262-.385-.04.2-.24,0-.249.193-.167-.164-.172-.154-.433-.449-.051.153-.383-.039-.533-.154-.433l.074.314a.311.311,0,0,1-.28-.071l.159-.513c-.249-.721-.94.932-1-.2-.185.343.154.3-.032.711-.166-.109-.185-.9-.24-.919-.182-.344-.4.711-.616.454-.01.193-.092.7-.327.829-.166-.111-.042-.832.106-.954.047-.006.053.058.037.121a.3.3,0,0,0,.143-.335l-.066.18c-.045-.211-.3-.248-.169-.539a.274.274,0,0,0-.05.412c-.169-.323-.359-.09-.555-.328.013.113,0,.338-.04.328-.3-.314-.237.315-.494.341-.068-.315.208-.664-.087-.484-.1-.227.085-.5.179-.639-.3.307-.351-.331-.46-.426l.15-.122a.189.189,0,0,1-.2.042l-.023.388c-.051-.08-.108-.095-.071-.249-.127.227-.093.631-.309.93-.045-.209-.322.138-.237-.362.243.235.087-.5.344-.526-.06.048-.116.032-.167-.048a.191.191,0,0,1,.058-.124c-.167-.505-.256.528-.536.45.1-.27.06-.542,0-.494.113.032-.056.476-.211.664-.129-.259-.233.114-.322.068l.084.127c-.1.269-.183.211-.33.269.04-.219.15-.121.127-.227-.254.455-.2-.581-.47-.3-.047-.209.114-.524.064-.671-.3.309-.15-.436-.45-.191-.019.389.013.3-.235.627l.442-.175-.37.487c.113.031.3-.18.349-.1-.187.277-.153.187-.171.51-.026-.6-.386.256-.479-.164l.219-.925c-.179-.475-.594.365-.895.051l.077.187c-.13.357-.23,0-.378.125a1.66,1.66,0,0,0,.027-.642c-.045.232-.257-.077-.426.536l-.069-.442c-.254-.23-.52.814-.772.65.154-.32.074-.568.312-.769-.093-.023-.164-.1-.211.117-.014-.206-.344.364-.368.051-.066.127-.146.45-.245.4a.634.634,0,0,1,.032-.153c-.032.153-.2.175-.185.539-.088-1.031-.808-.082-.9-.967a3.114,3.114,0,0,1-.859.076c.014-.093,0-.159.048-.117-.381-.365-.159.895-.524.505-.275-.56.151-.259,0-.476-.238-1.089-.45.079-.891-.6L7.3,1.124c-.37-.407-.405.341-.759.214a.833.833,0,0,0-.084-.169.8.8,0,0,1-.368.808c-.235-.436-.035-.222-.413-.681-.09.051.545.73.405.832a12.65,12.65,0,0,1-1.047-.973h.254c-.639-.64-.351-.013-.578-.137L4.494.746c-.386.047.285.74-.175.648l.261.212c.528.668-.6-.407-.257.084L3.448.984c.013.154.259.636.208.751A2.139,2.139,0,0,1,2.962.686C2.78.667,2.42.69,2.8,1.034,2.774.971,2.637.8,2.843.918c.5.541.666.8.378.766C1.3.31,1.879,1.235,0,.186A.774.774,0,0,1,.069.292c.93.856.195.769.775,1.517,1.532.568.179.217,1.857.962.191.175.195.208.093.172a3.73,3.73,0,0,0-.7.01c-.389-.069-.447-.282-.8-.415.117.312-.578-.116-.817,0,.524.154.885.418.819.563a4.672,4.672,0,0,1,.512-.05c1.113.727-.969.035.161.8L1.4,3.555c.442.338.719,1.088,1.89,1.43a.808.808,0,0,1-.587-.064A3.507,3.507,0,0,0,3.729,5.9c.394.3.689.534.59.83l-.274.021c.15.1.578.056.431.274-.1.027-.264.037-.241.095.125.04.59.138.555.339l-.328-.01c.182.87,1.007.357,1.358.6a1.116,1.116,0,0,0-.636.964L5.1,9.065c.172.446.915.37,1.382.6-.512.629.2.951.047,1.545a.9.9,0,0,1,.581-.24c-.072.159.568,0,0,.309L7.1,11.241c-.512.388-.259.481-.191.631l.75-.4c-.864.981.943.755.09,1.5.237-.013.3.1.533.087l-.4.212a.921.921,0,0,0,.3.713l-.322.09c.064.187,1.277-.393,1.388-.241l-.578.364c.174.3-.2.877.494.906-.092.04-.272.117-.322.08.056.153-.14.758.674.3-.545.269.1.343.426.4l-.418.166c.589-.1.729-.164.964-.031-.031.072-.306.193-.23.082-.143.256.441-.055.311.238l-.293.048c.042.177.175.1.521.053.211.031.037.359-.323.545.235-.079.579-.121.515.023a.59.59,0,0,1-.288.079c-.154.391.658.2.33.566a.828.828,0,0,0-.233.135c-.079-.224-.127-.409-.092-.405-.378.164-.376.365-.956.452.341.014,1.063-.006.954.241-.035.021-.069.043-.122.077h-.05c-.023.055.027.076.1.082-.04.08-.072.134-.058.188-.309.148-.09.269-.069.362.417-.175.4-.032.7-.278-.024.027-.056,0-.1-.048a.1.1,0,0,0-.06-.019l.04-.01a1.989,1.989,0,0,1-.117-.208c.241-.016.45-.014.257.177l.729-.145c-.537.356-.759.71-1.112.88.335.18.385.574,1.247.46.13.042-.2.172-.314.246-.1-.016-.1-.074-.227-.058.261.082.245.431.821.277-.182.283-.557.066-.368.3l-.185.021c-.734.816,1.718.418.743,1.377a.4.4,0,0,1,.177-.13c-.327.824.882,1.306.2,2.186-.129.23.246.171.553.233l-.467.14.59.093c.459.22-1.06.719-.241.948l.317-.1c-.042.143.253.394-.124.43.061,0,.344-.008.182.071l-.249.042.478.265c-.143.278-1,.1-1,.47a1.669,1.669,0,0,0,.952.224c0-.056.137-.161.388-.2l.151.113a3.658,3.658,0,0,0,2-.449l-.489-.174.349-.124.051.195c.323-.158.013-.19-.2-.24a.987.987,0,0,0,.381-.154l-.742-.127c.286-.072.59.018.727-.161-.344-.058-.634.2-.875.056.32-.162.6-.174.291-.259a.609.609,0,0,1,.405,0c-.246-.082-.143-.3-.544-.29.4-.188-.177-.37.523-.486-.175-.006-.589-.1-.639-.2.872.034-.032-.405.87-.534-.777.008-.439-.457-.9-.619.061,0,.187,0,.153.032.034-.158.249-.251.365-.375a3.072,3.072,0,0,1-1.223-.084c.545-.317.745-.072,1.3-.265-.494.13-.573-.18-.97-.018a1.776,1.776,0,0,1,.637-.356c-.771.174-.162-.092-.66-.077.327-.291.7-.241.415-.389a.607.607,0,0,1,.526-.048m-2.959-4.429.008,0c.026.037.048.068.063.087-.014-.016-.035-.04-.071-.084m-.167-.389a.538.538,0,0,0,.053.177c-.138.074-.293.122-.3.079.1-.019.151-.145.248-.256m-2.571,2c-.084-.034-.008-.087.074-.129a.4.4,0,0,0,.092.08l.055-.013a2.184,2.184,0,0,1-.22.061",
    transform: "translate(0 0.113)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46739",
    "data-name": "Path 46739",
    d: "M6.911,11.561c.013,0,.032,0,.04.011l.08-.072-.14.032Z",
    transform: "translate(4.196 7.002)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46740",
    "data-name": "Path 46740",
    d: "M13.9,3.267,13.9,3.256a.351.351,0,0,1,.006.066V3.267",
    transform: "translate(8.462 1.982)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46741",
    "data-name": "Path 46741",
    d: "M7.048,6.865l-.1.056.106-.016Z",
    transform: "translate(4.231 4.18)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46742",
    "data-name": "Path 46742",
    d: "M15.157,4.426a.367.367,0,0,0,.016.119.529.529,0,0,0-.016-.119",
    transform: "translate(9.229 2.695)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46743",
    "data-name": "Path 46743",
    d: "M15.769,4.563l.125.172a.567.567,0,0,0-.125-.172",
    transform: "translate(9.602 2.778)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46744",
    "data-name": "Path 46744",
    d: "M16.238,4.816c.013-.079.023-.138.031-.191l0,0Z",
    transform: "translate(9.887 2.814)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46745",
    "data-name": "Path 46745",
    d: "M8.76,3.67a.049.049,0,0,0-.032.013c-.087.071-.034.047.032-.013",
    transform: "translate(5.287 2.234)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46746",
    "data-name": "Path 46746",
    d: "M11.105,3.537a1.175,1.175,0,0,1-.159.182c.055.048.1.069.159-.182",
    transform: "translate(6.665 2.153)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46747",
    "data-name": "Path 46747",
    d: "M6.282,3.469l0-.008-.023,0Z",
    transform: "translate(3.812 2.104)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46748",
    "data-name": "Path 46748",
    d: "M10.846,3.631c.042.1.1.095.161.045-.045-.042-.093-.1-.161-.045",
    transform: "translate(6.604 2.197)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46749",
    "data-name": "Path 46749",
    d: "M18.347,4.958l.039.018c0-.031,0-.055,0-.072Z",
    transform: "translate(11.171 2.985)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46750",
    "data-name": "Path 46750",
    d: "M18.373,4.923l.04-.055c-.019,0-.035,0-.04.055",
    transform: "translate(11.187 2.964)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46751",
    "data-name": "Path 46751",
    d: "M18.484,4.8l-.085.116c.031,0,.069.014.085-.116",
    transform: "translate(11.203 2.92)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46752",
    "data-name": "Path 46752",
    d: "M17.7,4.814l-.014.164a.853.853,0,0,0,.014-.164",
    transform: "translate(10.771 2.931)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46753",
    "data-name": "Path 46753",
    d: "M17.5,4.863c.074.04.183.356.29.257l.013-.13c-.055.241-.227-.4-.3-.127",
    transform: "translate(10.657 2.919)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46754",
    "data-name": "Path 46754",
    d: "M16.762,3.728,17,3.871c-.035-.175-.077-.412.037-.45-.28-.533.042.4-.278.307",
    transform: "translate(10.206 1.982)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46755",
    "data-name": "Path 46755",
    d: "M16.318,3.485c.137-.069.018-.253.034-.351-.095.151-.121.19-.034.351",
    transform: "translate(9.904 1.908)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46756",
    "data-name": "Path 46756",
    d: "M12.869,2.994l.095-.4c-.114.039-.032.156-.095.4",
    transform: "translate(7.836 1.579)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46757",
    "data-name": "Path 46757",
    d: "M11.938,4.03l.048.272.127-.359Z",
    transform: "translate(7.269 2.401)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46758",
    "data-name": "Path 46758",
    d: "M11.989,2.151l.056-.048-.2.109Z",
    transform: "translate(7.212 1.28)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46759",
    "data-name": "Path 46759",
    d: "M6.107.916l-.064.5c.088-.076.212-.632.064-.5",
    transform: "translate(3.68 0.546)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46760",
    "data-name": "Path 46760",
    d: "M2.73.874C2.38.589,2.006.393,2.205.658c.179.051.536.282.524.216",
    transform: "translate(1.309 0.324)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46761",
    "data-name": "Path 46761",
    d: "M4.545,7.507l-.187.014.2.061Z",
    transform: "translate(2.654 4.571)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46762",
    "data-name": "Path 46762",
    d: "M18.408,5.538c-.023-.138-.13-.433-.167-.357l.121.518Z",
    transform: "translate(11.107 3.147)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46763",
    "data-name": "Path 46763",
    d: "M17.927,4.881a3.684,3.684,0,0,0,.246,1.179c-.08-.51,0-.311-.109-.914.037-.076.148.135.2.325-.019-.137.124.085.053-.241-.2-.373-.29-.362-.288-.008a1.6,1.6,0,0,1-.1-.341",
    transform: "translate(10.916 2.972)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46764",
    "data-name": "Path 46764",
    d: "M14.475,4.962l.039.061a.1.1,0,0,0-.039-.061",
    transform: "translate(8.814 3.021)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46765",
    "data-name": "Path 46765",
    d: "M12.41,4.776c.024-.011.04-.063.047-.111a.152.152,0,0,0-.047.111",
    transform: "translate(7.556 2.84)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46766",
    "data-name": "Path 46766",
    d: "M12.1,4.339l.027.04c-.006-.05-.014-.079-.027-.04",
    transform: "translate(7.37 2.631)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46767",
    "data-name": "Path 46767",
    d: "M14.512,5.024l-.1-.164c0,.174.051.129.1.164",
    transform: "translate(8.777 2.959)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46768",
    "data-name": "Path 46768",
    d: "M17.677,5.845a.414.414,0,0,0,.014-.15.38.38,0,0,1-.032.068Z",
    transform: "translate(10.752 3.467)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46769",
    "data-name": "Path 46769",
    d: "M15.359,4.7l.026,0c0-.061,0-.134,0-.217Z",
    transform: "translate(9.352 2.726)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46770",
    "data-name": "Path 46770",
    d: "M16.036,4.469A4.263,4.263,0,0,0,16.1,5.1a.871.871,0,0,1,0-.315c-.018-.084-.039-.185-.064-.314",
    transform: "translate(9.761 2.721)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46771",
    "data-name": "Path 46771",
    d: "M17.223,4.751l.016-.068-.016.068",
    transform: "translate(10.487 2.851)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46772",
    "data-name": "Path 46772",
    d: "M14.87,4.664c-.01-.066-.018-.125-.023-.161Z",
    transform: "translate(9.04 2.742)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46773",
    "data-name": "Path 46773",
    d: "M10.7,14.878l-.08-.008c.045.013.077.018.08.008",
    transform: "translate(6.466 9.054)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46774",
    "data-name": "Path 46774",
    d: "M9.285,15.6l-.021-.023-.251-.04Z",
    transform: "translate(5.488 9.458)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46775",
    "data-name": "Path 46775",
    d: "M11.542,3.9l0,.01c.034-.047.018-.04,0-.01",
    transform: "translate(7.028 2.359)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46776",
    "data-name": "Path 46776",
    d: "M4.612,2.63c.788.5,1.321,1.144,2.156,1.63C6.4,4.007,5.048,2.83,4.612,2.63",
    transform: "translate(2.808 1.601)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46777",
    "data-name": "Path 46777",
    d: "M17.66,5.758a.089.089,0,0,1-.048.018c.026.008.042,0,.048-.018",
    transform: "translate(10.724 3.506)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46778",
    "data-name": "Path 46778",
    d: "M5.952,3.643l.008.006.08.047-.088-.053",
    transform: "translate(3.624 2.218)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46779",
    "data-name": "Path 46779",
    d: "M9.723,3.612a1.887,1.887,0,0,0,.055.227.88.88,0,0,0-.055-.227",
    transform: "translate(5.92 2.199)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46780",
    "data-name": "Path 46780",
    d: "M11.093,4.411l-.031-.068c.008.043.019.061.031.068",
    transform: "translate(6.736 2.644)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46781",
    "data-name": "Path 46781",
    d: "M8.908,3.772c-.055-.061-.1-.146-.125-.095.019.032.032.055.045.079-.011-.071,0-.095.08.016",
    transform: "translate(5.348 2.229)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46782",
    "data-name": "Path 46782",
    d: "M7.878,3.291l.114.154.027-.016Z",
    transform: "translate(4.797 2.004)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46783",
    "data-name": "Path 46783",
    d: "M10.768,12.836a3.913,3.913,0,0,1-.405.055c.322-.021.438.135.405-.055",
    transform: "translate(6.31 7.816)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46784",
    "data-name": "Path 46784",
    d: "M17.63,5.635a.467.467,0,0,1,.019.2.14.14,0,0,0,.027-.034.764.764,0,0,0-.047-.164",
    transform: "translate(10.735 3.431)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46785",
    "data-name": "Path 46785",
    d: "M9.837,6.4l-.051-.085a.539.539,0,0,0,.051.085",
    transform: "translate(5.959 3.844)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46786",
    "data-name": "Path 46786",
    d: "M9.9,8.129l.063.023c.006-.016-.01-.027-.063-.023",
    transform: "translate(6.026 4.949)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46787",
    "data-name": "Path 46787",
    d: "M9.857,6.5c-.114-.2-.18-.312-.228-.394.024.045.043.08.077.145Z",
    transform: "translate(5.863 3.717)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46788",
    "data-name": "Path 46788",
    d: "M10.36,12.87h0Z",
    transform: "translate(6.308 7.836)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46789",
    "data-name": "Path 46789",
    d: "M15.343,21.037c.018-.166-.579-.09-.919-.134-.164-.195.439-.08.745-.142-.154-.125-.693-.224-.673-.314a.843.843,0,0,1,.256,0c-.475-.129-.029-.381-.624-.523a1.088,1.088,0,0,1,.148-.021,8.091,8.091,0,0,1-.816.032c-.011-.069-.378-.122.011-.156-.011.043.145.045.267.063l-.169-.071c.557-.077.193.1.607.092-.183-.145-.648-.3-.492-.415.547-.039.188.256.671.095l-.206.177c.861-.15-.058.109.862-.032.154-.24-.283-.256-.127-.492-.3-.042-.449.032-.753-.008-.563-.3,1.358-.317.616-.524-.367-.043-1.059-.027-.7-.217l.621.021c.047-.23-.895-.069-.494-.33.245.024.216.161.286.122.478-.187-.356-.084-.364-.2l.544-.066c-.095-.233-.526-.457-.65-.7a1.1,1.1,0,0,0,.5-.053c-.311-.3,0-.713.265-1.08l-.486-.056a.473.473,0,0,1,.3-.064c.158-.151-.3.035-.491,0-.043-.066.254-.134.4-.109-.431-.164-.944-.479-.484-.795l.146.021c.154-.212-.991-.027-.59-.267l.088.014c.122-.422-.375-.748.253-1.194-.677.1.2-.447-.727-.253.405-.325.586-.3.814-.69.023-.095-.6.026-.722-.048l.478-.13-.537,0,.55-.228-.15-.061a.646.646,0,0,1-.331.171c-.259-.084.228-.447.471-.523l-.505-.23a.954.954,0,0,1,.412,0c-.539-.04.491-.183,0-.222a1.794,1.794,0,0,1-.383.1c.261-.172.211-.37.042-.473l.335-.077c-.006-.285-.343-.492-.434-.78a1.14,1.14,0,0,1-.764.264l.481-.208c-.323.055-.156.151-.566.175.021-.124.536-.272.718-.267l-.216-.069c.145-.06.233-.058.423-.117-.162.029-.058-.072.016-.167.117.029.171-.039-.1.05l.15-.043c0-.018-.19,0-.233-.04a3.948,3.948,0,0,1-.784-.039c.124-.074.505-.079.442-.125-.28-.09-.452-.1-.779-.191a4.842,4.842,0,0,1,.777.146,5.114,5.114,0,0,0-.6-.356c-.212-.074-.3-.092-.483-.171-.1-.064.195.026.455.138l.058.027c-.433-.237-.088-.167.267-.013.348.137.7.351.05-.064l.066.042-.719-.51c.087.027.486.331.864.558-1.117-.8.106.018-.676-.582,1,.73.972.713.821.578s-.418-.376.3.219l-.533-.447c-.531-.454.3.245.42.349l-.775-.658c-.38-.357-.248-.3.248.138.4.348.827.747,1.026.944.113.119-2.447-2.449-1.255-1.29l.829.856c-.486-.508-.405-.467-.343-.422s.129.1-.121-.257l.3.391c.454.555.063.043-.246-.383.055.056.3.394.47.616.225.311-.438-.65-.064-.13.053.08.108.161.137.2-.164-.246.076.076-.315-.51.206.29-.069-.222.158.122-.306-.607.214.317-.2-.537.434.885.376.722.264.338.1.256.1.267.241.621a4.709,4.709,0,0,0-.158-.579c.182.5.127.3.125.154s.016-.262.109.339a.93.93,0,0,1,.327-.766c-.148.713-.142.04-.224.8a1.745,1.745,0,0,1,.2-.52c.161-.138.3-.22.438-.1.058.116-.113.3-.169.412.375-.219.59.2.946-.14a.489.489,0,0,1-.1.183c.06-.013.108.127.163-.2l-.069.079c0-.486.4-.944.447-1.192-.257.914.224.28-.125,1.432a.884.884,0,0,0,.148-.42c.042.072.037.2-.06.441.227-.142.214-.5.388-.462a3.867,3.867,0,0,1-.119.394c.14-.293.274-.581.4-.431-.023.095-.024.22-.068.212.267-.014.545-.766.782-.433-.164.679.068.238.014.837l.172-.158-.029-.3c.134.027.293-.393.386-.19l-.122.238.259-.093-.119-.238c.161-.3.058-.758.212-.578-.039.058.127.016.166.375v0c.079-.187.159-.381.243-.225.011.193-.068.66-.061.79.1-.5.32-.116.431-.644a2.562,2.562,0,0,0-.048.5l.076-.4a.774.774,0,0,1,.035.449c.18.084-.018-.761.182-.428a1.072,1.072,0,0,1-.051.156c.211.175.428-.248.619-.042.045.6-.179.143-.124.655.3-.108.615-.7.891-.571l-.053-.064c.031-.854.211.417.348.011a1.506,1.506,0,0,0-.027.378c.2.132.391-.219.666-.494l-.026.219c.122.2.3.1.431.188.023-.222.095-.191.032-.507.47,1.213.648-.711,1.075.283-.04.006-.076.2-.043.2l.262-.235a1.884,1.884,0,0,0-.154-.5c.01-.224.068-.4.135-.41a1.214,1.214,0,0,0,.151.792c-.023-.113-.019-.24-.039-.354.228.637-.069-.745.183-.328l.014.195c.061-.108.093-.372.179-.327.093.422-.05.208-.006.56.113-.04.1-.835.267-.423-.029.124-.1.135-.127.259.183.484.18.357.275.423l-.01-.01.228.191-.071-.125c-.04-1.133.254-.254.314-1.012-.058.718.042.4.114.883a.935.935,0,0,1,.179.4c.019-.4.212.277.233-.312.035.153.1,0,.156.388.1-.143-.082-.262-.109-.457.072-.552.565.544.666-.233.156-.348.071-.872.2-1.174a1.07,1.07,0,0,1,.084.568c.166.2.241.137.3-.061a1.167,1.167,0,0,0,.142.405c.074-.063-.092-.568.077-.376a5.882,5.882,0,0,1,.08.634c.063-.169.082-.479.145-.645a1.477,1.477,0,0,1,.063.6.884.884,0,0,0,.145-.751l-.116-.127c.035-.032.125.351.117.434,0,.356-.183-.1-.232-.253L26.22,7.5c-.323-.864-.243.225-.405.217L25.7,7.052l0,.576A1.34,1.34,0,0,1,25.55,7c-.183-.3-.031.251-.208-.085a.227.227,0,0,1-.026-.114l-.05.217c-.014-.142-.13-.455-.047-.375-.264-.335-.164.553-.348.076l0-.043c-.191.278.09.484.029,1.091L24.522,6.61l.08.484c-.029-.011-.087-.035-.119-.23-.024.351.061.206.072.529-.212-.407-.3.27-.479-.491.026.373.172.261.09.539-.2-.819-.125.171-.311-.19-.043-.433.1-.225-.077-.587.063.735-.243-.119-.309.035.092.576-.163.28-.291.5-.019-.195-.344-.28-.516-.471l-.008-.1c.048.589-.117.5-.214.634a1.8,1.8,0,0,1,0-.658l-.1.016a.6.6,0,0,1-.08.37l-.024-.442c-.13.04-.219.555-.425.272.026.41.254,1.131.082,1.419a2.465,2.465,0,0,1-.026-.7c-.014.031-.042.188-.084.1l.042-.378c-.1-.158-.014.314-.084.285-.026-.317-.068-.222-.08-.475.014-.032.069.127.082,0a.821.821,0,0,1-.228-.471c.021.18.034.426-.016.471-.137.034-.077-.376-.167-.534-.018.224-.119,0-.09.476-.04,0-.063-.22-.085-.348-.058.214-.325.085-.219.582l.021.032L20.95,7.3c-.217.484-.5-.256-.729-.045l0-.159c-.135.185-.307.116-.405.46-.043,0-.1-.288-.082-.478-.1.119-.121.3-.27.031.108-.275-.034-.248.109-.2-.135-.14-.159-.4-.315.035.058-.407-.09-.516-.156-.4l.087.293c-.074.058-.138.021-.2-.016l.051-.534c-.24-.656-.55,1.1-.7-.013-.1.368.134.275.043.706-.127-.082-.206-.858-.245-.862-.146-.309-.22.767-.388.552a1.611,1.611,0,0,1-.171.869c-.129-.08-.085-.809.01-.956.032-.014.042.048.034.113a.4.4,0,0,0,.079-.354l-.034.188c-.047-.2-.22-.191-.148-.5a.354.354,0,0,0-.011.412c-.134-.29-.253-.039-.4-.243.013.108.011.333-.014.328-.217-.267-.151.346-.331.407-.058-.3.124-.685-.076-.465a1.049,1.049,0,0,1,.108-.653c-.2.346-.243-.275-.315-.352l.1-.142c-.06.084-.1.079-.134.071l-.014.383a.258.258,0,0,1-.048-.238,7.207,7.207,0,0,1-.209.956c-.031-.2-.225.171-.163-.333.166.2.063-.505.237-.557-.04.055-.077.045-.113-.029a.257.257,0,0,1,.042-.129c-.1-.479-.179.55-.368.5.074-.277.051-.541.011-.486.074.019-.048.475-.159.677-.082-.241-.166.138-.225.1l.055.116c-.079.277-.135.228-.241.3.035-.22.109-.135.1-.238-.2.476-.116-.547-.315-.249-.021-.2.106-.526.08-.666-.225.328-.071-.418-.29-.154a.962.962,0,0,1-.206.634l.315-.2-.288.505c.077.024.219-.2.251-.122a.824.824,0,0,0-.15.516c.018-.587-.291.277-.33-.132l.222-.924c0-.219-.222-.145-.407-.039s-.344.235-.536.042l.116.212c-.071.372-.233-.021-.354.1a1.9,1.9,0,0,0-.15-.713c.026.257-.32-.13-.264.562L12.8,5.273c-.385-.311-.134.924-.4.726-.039-.386-.254-.7-.129-.924-.106-.039-.225-.14-.145.124-.146-.264-.114.4-.341-.018.023.156.179.578.064.5a1.727,1.727,0,0,1-.085-.2,1.761,1.761,0,0,0,.246.713c-.405-.7-.624-.782-.787-.811s-.288-.018-.824-.735a.669.669,0,0,1-.465.034c-.1-.156-.191-.269-.111-.195-.671-.658.977,1.5.3.809-.861-1-.227-.43-.586-.824-.727-.948-.8-.948-.808-.848s.077.307-.529-.344L8.16,3.189c-.785-.8.172.541-.209.262l-.288-.328A6.128,6.128,0,0,1,8.607,4.6c-.8-.886-.352-.433-1.277-1.387.014.076,1.429,1.5,1.508,1.685C8.274,4.349,7.759,3.846,6.67,2.785l.18.063c-1.4-1.387-.275-.117-.616-.409l-.573-.587c-.2-.01,1.38,1.54.959,1.266l.521.491c1.48,1.491-1.06-.961.013.135L5.389,2.09,6.744,3.558c.066.074.122.135.169.187l-.8-.766C5.38,2.256,5.024,1.849,4.569,1.363c-.127-.071-.288-.114.217.391l.336.325L4.95,1.907C4.8,1.756,4.656,1.6,4.9,1.814l.814.8.848.848a3.431,3.431,0,0,1,.365.412C3.573.848,6.416,3.64,4.06,1.688c.732.738.74.84.66.895s-.232.088.048.47c2.058,1.482.172.225,2.367,1.884.206.212.191.224.056.127-.367-.216-.719-.409-1.054-.576a11.956,11.956,0,0,1-1.012-.8c.045.214-.8-.505-1.2-.645.706.473,1.125.859.975.869l.766.38c1.319,1.142-1.417-.734-.085.444l-.7-.545A8.624,8.624,0,0,0,7.027,6.2a3.4,3.4,0,0,1-.792-.447A5.516,5.516,0,0,0,7.3,6.909c.434.409.7.679.462.743L7.4,7.482c.158.14.734.4.455.394C7.711,7.823,7.5,7.721,7.5,7.76c.15.1.718.442.6.5l-.423-.216c-.113.431,1.3,1,1.614,1.321-.829-.1-.922.269-.957.478L8.218,9.84c.182.647,1.065.952,1.511,1.34-.663.438-.1.708-.41,1.125a1.265,1.265,0,0,1,.613-.135c-.113.109.528.039-.095.224l0-.027c-.592.241-.391.327-.376.439l.819-.228c-1.107.632.664.629-.37,1.08.222.014.241.1.463.117l-.442.109a.466.466,0,0,0,.064.534l-.328.026c0,.137,1.321-.129,1.377-.006l-.655.185c.058.238-.481.589.171.7-.1.016-.293.045-.328.013,0,.116-.368.505.542.3-.594.109-.014.253.267.343l-.444.051c.581.016.737,0,.917.127-.053.045-.351.087-.245.021-.214.158.434.031.22.216l-.291-.013c-.014.13.135.1.478.121.19.055-.076.257-.476.328.249-.016.587.011.478.1a.827.827,0,0,1-.3.006c-.282.246.552.254.129.45a1.06,1.06,0,0,0-.262.053c-.008-.167,0-.306.037-.3a3.378,3.378,0,0,1-1.047.151c.32.066,1.014.175.833.327l-.14.032-.048-.008c-.037.034,0,.056.076.074-.063.048-.111.079-.113.119-.338.048-.167.169-.177.235.45-.043.388.05.751-.064-.032.014-.056-.008-.08-.05a.09.09,0,0,0-.048-.026l.04,0a.922.922,0,0,1-.048-.164c.233.031.433.071.19.167l.738.032c-.619.15-.952.352-1.337.405.264.185.195.463,1.052.552.113.053-.24.08-.372.108-.087-.031-.077-.071-.2-.084.224.108.108.343.7.351-.265.159-.547-.064-.447.137l-.182-.023c-.943.41,1.525.636.312,1.1a.507.507,0,0,1,.209-.051c-.557.494.486,1.084-.41,1.541-.182.13.195.172.476.282l-.487-.006.547.195c.388.256-1.207.257-.471.6h.33c-.074.088.153.328-.219.269.058.016.335.071.159.088l-.253-.027.4.291c-.206.161-1-.158-1.08.095a2.086,2.086,0,0,0,.87.373c.018-.039.171-.079.422-.047l.121.113a4.958,4.958,0,0,0,2.035.15l-.431-.233.367-.006,0,.148c.351-.035.056-.13-.142-.216a1.2,1.2,0,0,0,.405-.019l-.689-.257c.294.014.568.148.743.053-.32-.119-.661,0-.862-.161.348-.039.621.016.344-.113a.807.807,0,0,1,.391.092c-.219-.113-.068-.24-.459-.327.431-.04-.076-.3.627-.219-.167-.045-.542-.2-.566-.285.835.22.074-.29.977-.177-.751-.169-.307-.417-.714-.634.06.014.18.043.14.056.071-.1.3-.119.452-.182a3.9,3.9,0,0,1-1.152-.327c.613-.1.737.113,1.323.1-.51-.018-.5-.251-.928-.224a2.255,2.255,0,0,1,.708-.111c-.787-.045-.13-.1-.611-.2.393-.134.74-.018.505-.183a.791.791,0,0,1,.518.079m-1.506-3.731.008,0,.034.074c-.008-.016-.021-.035-.042-.072M13.8,17a.271.271,0,0,0,0,.135c-.154.029-.315.034-.311,0,.106,0,.187-.077.314-.138m-3.052.938c-.069-.037.018-.061.109-.076a.256.256,0,0,0,.063.072h.056l-.228,0",
    transform: "translate(2.393 0.804)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46790",
    "data-name": "Path 46790",
    d: "M8.542,11.672c.011,0,.031.008.035.016l.1-.035-.143,0Z",
    transform: "translate(5.195 7.092)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46791",
    "data-name": "Path 46791",
    d: "M14.505,5.01,14.5,5l.016.063c0-.021-.006-.035-.01-.053",
    transform: "translate(8.828 3.044)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46792",
    "data-name": "Path 46792",
    d: "M10.132,8.3l-.111.031h.1Z",
    transform: "translate(6.102 5.057)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46793",
    "data-name": "Path 46793",
    d: "M15.608,5.873a.441.441,0,0,0,.037.113.566.566,0,0,0-.037-.113",
    transform: "translate(9.504 3.576)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46794",
    "data-name": "Path 46794",
    d: "M16.071,5.877l.129.14a.566.566,0,0,0-.129-.14",
    transform: "translate(9.786 3.578)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46795",
    "data-name": "Path 46795",
    d: "M16.453,6.026c-.01-.079-.016-.138-.023-.193l0,0Z",
    transform: "translate(10.003 3.55)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46796",
    "data-name": "Path 46796",
    d: "M10.771,6.236a.046.046,0,0,0-.026.016c-.069.077-.027.05.026-.016",
    transform: "translate(6.521 3.797)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46797",
    "data-name": "Path 46797",
    d: "M12.545,5.813a1.435,1.435,0,0,1-.1.206c.045.039.08.05.1-.206",
    transform: "translate(7.576 3.539)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46798",
    "data-name": "Path 46798",
    d: "M9.823,6.376l0-.01h0Z",
    transform: "translate(5.978 3.876)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46799",
    "data-name": "Path 46799",
    d: "M12.365,5.942c.04.093.082.077.124.018-.037-.034-.079-.084-.124-.018",
    transform: "translate(7.529 3.598)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46800",
    "data-name": "Path 46800",
    d: "M17.986,5.746l.032.01c-.006-.029-.013-.053-.018-.071Z",
    transform: "translate(10.952 3.461)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46801",
    "data-name": "Path 46801",
    d: "M18,5.708l.014-.06c-.013,0-.024.01-.014.06",
    transform: "translate(10.956 3.439)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46802",
    "data-name": "Path 46802",
    d: "M18.035,5.569,18,5.7c.023,0,.053,0,.031-.127",
    transform: "translate(10.962 3.391)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46803",
    "data-name": "Path 46803",
    d: "M17.494,5.724l.032.161c-.006-.034-.018-.085-.032-.161",
    transform: "translate(10.652 3.485)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46804",
    "data-name": "Path 46804",
    d: "M17.361,5.815c.063.024.22.307.27.19l-.024-.129c.023.246-.262-.341-.246-.061",
    transform: "translate(10.571 3.494)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46805",
    "data-name": "Path 46805",
    d: "M16.528,4.87l.2.093c-.066-.162-.153-.385-.084-.444-.322-.463.125.376-.117.351",
    transform: "translate(10.061 2.666)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46806",
    "data-name": "Path 46806",
    d: "M16.192,4.722c.079-.1-.045-.249-.058-.348a.342.342,0,0,0,.058.348",
    transform: "translate(9.811 2.663)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46807",
    "data-name": "Path 46807",
    d: "M13.734,4.958l.01-.412c-.071.058,0,.159-.01.412",
    transform: "translate(8.349 2.768)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46808",
    "data-name": "Path 46808",
    d: "M13.212,6.156l.069.257.048-.376Z",
    transform: "translate(8.045 3.676)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46809",
    "data-name": "Path 46809",
    d: "M13.043,4.3l.034-.056-.125.14Z",
    transform: "translate(7.886 2.586)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46810",
    "data-name": "Path 46810",
    d: "M7.838,3l.473.775c0-.1-.447-.932-.473-.775",
    transform: "translate(4.772 1.817)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46811",
    "data-name": "Path 46811",
    d: "M5.519,2.317c-.7-.655-1.269-1.144-.69-.555.2.145.809.692.69.555",
    transform: "translate(2.795 0.912)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46812",
    "data-name": "Path 46812",
    d: "M7.589,8.516l-.179,0,.166.06Z",
    transform: "translate(4.512 5.182)",
    fill: "#3db6fb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpskillingPathwaysArrow);
export default __webpack_public_path__ + "static/media/upskillingPathwaysArrow.85ba92960a6554478e3af0d4e3db0f99.svg";
export { ForwardRef as ReactComponent };